<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="会员列表" name="1">
      <MemberAdd :updataID='updataID'></MemberAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import MemberAdd from '../../../../static/form/MemberAdd.vue'
export default {
  components: {
    MemberAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Membergl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/MemberUpdate.vue